import React, { useState, useEffect } from "react";
import styled from "styled-components"

import Layout from "../components/layout"
import Container from "../components/container"

import FestivalPreview from "../components/festival-preview"
import ShowFeatured from "../components/show-featured";
import ShowListing from "../components/shows-listing"

import { getAllShows } from "../shows"
import { Link } from "react-router-dom";

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Shows = styled.section`
  margin-bottom: 100px;

  h2, h3 {
    text-align: center;
  }
`
const UpcomingShow = styled.section`
`
const ComingSoon = styled.section`
  margin: 70px 0px 200px 0px;
  text-align: center;
`

function HomePage(props) {
  const [upcomingShow, setUpcomingShow] = useState(null);
  const [shows, setShows] = useState([]);
  const [pastShows, setPastShows] = useState([]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/", title: "Home"});
  }, []);

  useEffect(() => {
    const orderedShows = getAllShows();
    const upcomingShows = [];
    const oldShows = [];
    const today = new Date();

    today.setHours(0,0,0,0);

    for (const show of orderedShows) {
      if (show.date < today && (!show.endDate || show.endDate < today))
        oldShows.push(show);
      else
        upcomingShows.push(show);
    }

    setShows(upcomingShows);
    setPastShows(oldShows);
  }, []);

  return (
    <Layout page="home" title="Marshall Artists Series">
      {/* <ComingSoon>
        <h1>
          2024-2025 season information coming soon
        </h1>
        <h2>
          For information call 304-696-6656        
        </h2>
      </ComingSoon> */}
      {upcomingShow && 
        <UpcomingShow>
          <ShowFeatured show={upcomingShow} />
        </UpcomingShow>
      }
      <Shows>
        {(shows.length > 0) && <h2>Upcoming Shows</h2>}

        {shows.map((show, index) => {
            return (
              <div key={index}>
                  <show.previewTemplate show={show} />
              </div>
            )
        })}   

        {(pastShows && pastShows.length > 0) && 
          <Container>
            <ShowListing 
              heading="Past Shows"
              shows={pastShows} 
            />
          </Container>
        }
      </Shows>  
    </Layout>
  );
}

export default HomePage;